import request from '@/utils/request'

export function getUserLabelList(data) {
  return request({
    url: 'api/v1/user-label/list',
    method: 'post',
    data: data
  })
}

export function exportUserLabelCfg(data) {
  return request({
    url: 'api/v1/user-label/export',
    method: 'post',
    data: data
  })
}

export function importUserLabelCfg(data) {
  return request({
    url: 'api/v1/user-label/import',
    method: 'post',
    data: data
  })
}
